/* eslint-disable react-hooks/exhaustive-deps */
import {
  FilterTypes,
  type IFilter,
} from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import type { IProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import ColorFilter from "@/app/components/common-filter-builder/filter/filter-components/ColorFilter";
import DropDownFilter from "@/app/components/common-filter-builder/filter/filter-components/DropDownFilter";
import PriceRager from "@/app/components/common-filter-builder/filter/filter-components/PriceRager";
import SelectButtons from "@/app/components/common-filter-builder/filter/filter-components/SelectButtons";
import SelectImages from "@/app/components/common-filter-builder/filter/filter-components/SelectImages";
import SelectOption from "@/app/components/common-filter-builder/filter/filter-components/SelectOption";
import TagsFilter from "@/app/components/common-filter-builder/filter/filter-components/TagsFilter";

interface IAttributesBuilder {
  productChildren: IProductDetails[];
  attribute: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  outOfStockKeys?: string[];
  attributesMaxWidth?: number;
}
const ProductAttributesBuilder: React.FC<IAttributesBuilder> = ({
  attribute,
  state,
  setState,
  unAvailabeKeys = [],
  outOfStockKeys = [],
  productChildren,
  attributesMaxWidth,
}) => {
  if (attribute.data?.length === 1) return null;
  switch (attribute.configurations.type) {
    case FilterTypes.carousel:
      return (
        <SelectButtons
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
        />
      );
    case FilterTypes.color_selector:
      return (
        <ColorFilter
          sliderMaxWidth={attributesMaxWidth}
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
        />
      );
    case FilterTypes.checkbox:
      return (
        <SelectOption
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
        />
      );
    case FilterTypes.tags:
      return (
        <TagsFilter
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
        />
      );
    case FilterTypes.range_slider:
      return (
        <PriceRager filter={attribute} state={state} setState={setState} />
      );
    case FilterTypes.dropdown:
      return (
        <DropDownFilter
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
        />
      );
    case FilterTypes.images:
      return (
        <SelectImages
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          productChildren={productChildren}
          sliderMaxWidth={attributesMaxWidth}
        />
      );

    default:
      return null;
  }
};
export default ProductAttributesBuilder;
